import { render, staticRenderFns } from "./mainFooter.vue?vue&type=template&id=3ded23af&scoped=true"
import script from "./mainFooter.vue?vue&type=script&lang=js"
export * from "./mainFooter.vue?vue&type=script&lang=js"
import style0 from "./mainFooter.vue?vue&type=style&index=0&id=3ded23af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ded23af",
  null
  
)

export default component.exports